import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivityCollaborationInvitation, ActivityCollaborationInvitationConfirmed, ActivityParent, ActivityParentType, ActivityService, AuthenticatedIdentity, AuthenticationService, ClienteleGroup, ConfirmActivityCollaboration, CurrentUser } from '../../domain';
import { ConsoleService } from '../../widgets/console.service';
import { ActivityModalService } from '../activity-modal.service';

@Component({
	templateUrl: './activity-collaboration-confirmation-modal.component.html',
	styleUrls: ['./activity-collaboration-confirmation-modal.component.scss']
})
export class ActivityCollaborationConfirmationModalComponent {
	invite: ActivityCollaborationInvitation;
	dto: ConfirmActivityCollaboration;
	clienteleGroups: ClienteleGroup[] = [];
	parents: ActivityParent[] = [];
	saving: boolean = false;
	editAfterSaving: boolean = false;
	ActivityParentType = ActivityParentType;
	currentUser: CurrentUser;

	constructor(
		public dialogRef: MatDialogRef<ActivityCollaborationConfirmationModalComponent>,
		private snackBar: MatSnackBar,
		private console: ConsoleService,
		private svc: ActivityService,
		private activityModalService: ActivityModalService,
		private authSvc: AuthenticationService,
		@Inject(MAT_DIALOG_DATA) data: any
	)
	{
		svc.getAvailableClienteleGroups(false).then(cgs => {
			this.console.log("ClienteleGroups: ", cgs);
			this.clienteleGroups = cgs;
		});
		svc.getAvailableParents().then(ps => this.parents = ps);
		this.invite = data.invite;
		this.dto = new ConfirmActivityCollaboration(this.invite.originalActivity.id, "", null, null, null);
		this.console.log("invite: ", this.invite);

		authSvc.currentIdentity.subscribe(i =>
			i.doWithValue((i: AuthenticatedIdentity) => {
				this.currentUser = i.user;
			})
		);
	}

	public static open(matDialog: MatDialog, invite: ActivityCollaborationInvitation): MatDialogRef<ActivityCollaborationConfirmationModalComponent>
	{
		return matDialog.open(ActivityCollaborationConfirmationModalComponent,{
			width:'500px',
			hasBackdrop: true,
			autoFocus: false,
			data: {
				invite
			}
		});
	}

	hasClienteleContacts(): boolean {
		return this.invite.originalActivity.clienteleContactCount > 0;
	}

	// If the collaboration invite activity type is not available to the user, 
	// they must select a new type in order to confirm the collaboration. 
	mustUpdateActivityType(): boolean {
		if (!this.currentUser)
			return false;
		
		const types = this.svc.getActivityTypes().getFilteredByUser(this.currentUser);
		return types.getTypeIdBySubTypeId(this.invite.originalActivity.activitySubTypeId) === undefined;
	}

	getActivities() {
		if (this.currentUser) {
			return this.svc.getActivityTypes().getFilteredByUser(this.currentUser).all;
		}
		return this.svc.getActivityTypes().all;
	}

	getUpdateActivityTypeTooltip(): string {
		return "Per the E-Book, only Academic Coordinator positions are required to use Academic Coordination tables in their Supporting Documentation to reflect" 
		+ " their review criteria. As such, Academic Coordination activity types in Project Board can only be created or used by Academic Coordinators.";
	}

	cancel(){
		this.dialogRef.close(new ActivityCollaborationConfirmationModalResponse(false, false, null));
	}

	save(){

		if (this.mustUpdateActivityType() && !this.dto.activitySubTypeId) {
			this.snackBar.open("Unable to add activity: Type is required");
			return;
		}

		this.saving = true;
		this.svc.confirmCollaboration(this.dto).then(result =>
			result.matchDo(
				(newActivityId: ActivityCollaborationInvitationConfirmed) => {
					this.snackBar.open("Activity added")
					this.dialogRef.close(new ActivityCollaborationConfirmationModalResponse(true, this.editAfterSaving, newActivityId.activityId));
					this.saving = false;
				},
				msg => {
					this.snackBar.open("Unable to add activity: " + msg)
					this.saving = false;
				}
			));
	}
}

export class ActivityCollaborationConfirmationModalResponse 
{
	constructor(
		public readonly confirmed: boolean,
		public readonly editAfterSaving: boolean,
		public readonly originalActivityId: number
	){}
}